import { SnackbarContext } from "App";
import { PinnedLogsContext } from "components/AllLogHistoryNew";
import useUserContext from "hooks/context-hooks/useUserContext";
import { useContext } from "react";
import { useMutation } from "react-query";
import { PUT } from "utils/restUtils";

export const useUpdatePinnedLog = (callback: () => void) => {
  const { token, user } = useUserContext();

  const { setSnack } = useContext(SnackbarContext);

  const contextData = useContext(PinnedLogsContext);
  const { mutate, isLoading } = useMutation(
    async ({
      logId,
      callType,
      isPinned,
    }: {
      logId: string;
      callType:
        | "web_form_log"
        | "chat_widget"
        | "sms_log"
        | "call_log"
        | "note";
      isPinned: boolean;
    }) => {
      const response = await PUT(
        `https://test.dentistfind.com/api/v1/communication_logs/${logId}?call_type=${callType}&is_pinned=${isPinned}`,
        { api_token: token }
      );
      return response.data;
    },
    {
      onSuccess: (e) => {
        callback && callback();
        contextData?.refetchPinnedLogs && contextData.refetchPinnedLogs();
        contextData?.refetchNotes && contextData.refetchNotes();
        console.log(e.data[0].is_pinned);
        setSnack({
          open: true,
          severity: "success",
          message: `${
            e?.data[0]?.is_pinned ? "Pinned" : "Removed pin"
          } successfully!`,
        });
      },
    }
  );

  const mutateFn = (val: Variables) => {
    if (val.isPinned === true && contextData?.pinnedLogs?.length >= 5)
      setSnack({
        open: true,
        severity: "warning",
        message: "You can only pin up to 5 items.",
      });
    else mutate(val);
  };

  return [mutateFn, isLoading] as [typeof mutate, boolean];
};
type Variables = {
  logId: string;
  callType: "web_form_log" | "chat_widget" | "sms_log" | "call_log" | "note";
  isPinned: boolean;
};
